const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};
/* GA: expose for customizer Vue bundle (top-level const isn't a window prop) */
window.PUB_SUB_EVENTS = PUB_SUB_EVENTS;
